<div class="error-container">
  <div class="error-content">
    <h1 class="error-title">{{ title }}</h1>
    <p class="error-message">
      {{ message }}
    </p>
    @if (button) {
      <button class="error-button" (click)="goHome()">
        {{ "error_page.back_to_homepage" | transloco }}
      </button>
    }
  </div>
</div>
